(function ($, Promise) {

        // Constructor
        function PACLexiqueScreenSaver(data) {

            this.counter = 0;
            this.state = true;
            this.ticker = new PIXI.Ticker();

            // Init game canvas (PIXI)
            this.canvas = $("#screensaver-canvas").get(0);
            this.renderer = PIXI.Renderer.create({
                width: 1366,
                height: 768,
                backgroundColor: 0x272625,
                view: this.canvas,
                resolution: 1,
                antialias: true,
                // resolution: window.devicePixelRatio || 1,
            });

            this.textures = [];
            this.sprites = [];
            this.animateIndex = 0;
            this.stage = new PIXI.Container();
            this.onScreenSimultaneously = 20;
            this.padding = 200;

            // Load textures
            for (var i = 0; i < data.categories.length; i++) {
                for (var j = 0; j < data.categories[i].items.length; j++) {
                    this.textures.push(PIXI.Texture.from(data.categories[i].items[j].image, {resolution: 3, resourceOptions: {scale: 3}}));
                }
            }

            // Load sprite
            for (var i = 0; i < this.textures.length; i++) {
                var x = constrain((i * (-(this.renderer.width + (this.padding * 2)) / (this.onScreenSimultaneously - 2)) + this.renderer.width + this.padding), -this.padding, this.renderer.width + this.padding);
                // var y = getRandomInt(0, this.renderer.height);
                var y = (i * 200 % this.renderer.height);
                var speed = getRandomFloat(0.75, 1.25);
                // var speed = 1.0;

                this.sprites[i] = new PIXI.Sprite(this.textures[i]);
                this.sprites[i].anchor.set(0.5);
                this.sprites[i].position.set(x, y);
                this.sprites[i].blendMode = PIXI.BLEND_MODES.MULTIPLY;
                this.sprites[i].speedFactor = speed;
                this.sprites[i].scale.set(speed);
                this.stage.addChild(this.sprites[i]);

                this.sprites[i].animate = false;
            }


            for (var i = 0; i < this.onScreenSimultaneously; i++) {
                this.animateNext();
            }

            // Listen for animate update
            this.ticker.add($.proxy(this.draw, this));
        }

        PACLexiqueScreenSaver.prototype.start = function () {
            this.state = true;

            for (var i = 0; i < this.sprites.length; i++) {
                this.sprites[i].alpha = 1;
            }

            this.ticker.start();
        }

        PACLexiqueScreenSaver.prototype.stop = function () {
            this.ticker.stop();
            this.state = false;
        }

        PACLexiqueScreenSaver.prototype.animateOut = function () {
            for (var i = 0; i < this.sprites.length; i++) {
                TweenMax.to(this.sprites[i], 0.6 * this.sprites[i].speedFactor, {
                    alpha: 0,
                    ease: this.defaultEasing,
                    onComplete: this.stop,
                    onCompleteScope: this,
                });
            }
        }

        PACLexiqueScreenSaver.prototype.animateNext = function () {
            this.sprites[this.animateIndex].animate = true;
            this.animateIndex = (this.animateIndex + 1) % this.sprites.length;
        }

        // Load settings JSON (with promise)
        PACLexiqueScreenSaver.prototype.draw = function (delta) {

            this.counter += delta;

            if (!this.stopped) {
                for (var i = 0; i < this.sprites.length; i++) {

                    if (this.sprites[i].animate == true) {
                        this.sprites[i].position.x += 0.65 * delta * this.sprites[i].speedFactor;
                    }

                    if (this.sprites[i].position.x > this.renderer.width + this.padding) {
                        this.sprites[i].position.x = -this.padding;
                        this.sprites[i].animate = false;
                        this.animateNext();
                    }
                }
            }

            // Trigger rendering
            this.renderer.render(this.stage);
        }

        PACLexiqueScreenSaver.prototype.reset = function () {

        }

        // Expose PACLexiqueScreenSaver
        window.PACLexiqueScreenSaver = PACLexiqueScreenSaver;
    }
)
(jQuery, Promise);
